// Refine playback decisions are separate from the video events, which can
// arrive repeatedly at an end boundary. This keeps full-Assembly and cut
// transition loop modes testable without a browser/media fixture.
export function refinePlaybackEndAction({kind,active=0,count=0,loop=false,incomingReady=false}={}){
 if(kind==='assembly'){
  if(active+1<count)return 'advance';
  return loop?'restart-assembly':'stop';
 }
 if(kind==='cut'){
  if(incomingReady)return 'join';
  return loop?'restart-cut':'stop';
 }
 if(kind==='incoming')return loop?'restart-cut':'stop';
 return 'stop';
}

// A previously buffered URL may not generate another canplay event when the
// active passage changes. Resume by passage ID after media is ready, never
// from the previous passage's still-mounted video state.
export function shouldResumeRefineSequence({continuing=false,loadedBlockId,activeBlockId,videoReady=false}={}){
 return Boolean(continuing&&videoReady&&activeBlockId&&loadedBlockId===activeBlockId);
}
